import React, { useRef } from 'react'
import { Grid, GridProps } from '@mui/material'
import { StorageSoftwareVersion } from 'src/Libs/wallboxes/types'
import { isVersionGreaterThanOrEqualTo } from 'src/Libs/wallboxes/utils'
import { useScrollToHash } from 'src/Libs/navigation/hooks'
import { SystemSettingHashes } from 'src/Libs/navigation/types'
import useActiveInstallationContext from 'src/Libs/installations/hooks/use-active-installation-context'

interface Props extends GridProps {
  children: React.ReactNode
}

/**
 * Display grid container for Wallbox settings form
 */
const WallboxSettingsFormGridContainer: React.FC<Props> = ({ children }) => {
  const containerRef = useRef<HTMLDivElement | null>(null)
  useScrollToHash(containerRef, SystemSettingHashes.WallboxSettings)

  const { storage } = useActiveInstallationContext()
  const softwareVersion = storage?.softwareRelease
  const isNewLayout = softwareVersion ? isVersionGreaterThanOrEqualTo(softwareVersion, StorageSoftwareVersion.X_2024_04) : false

  return (
    <Grid container spacing={isNewLayout ? 2 : 5} ref={containerRef}>
      {children}
    </Grid>
  )
}

export default WallboxSettingsFormGridContainer
